<template>
  <!-- TODO: revisar cuando se cambien las regiones del back y ya no tengas el - para quitar las condiciones (.includes("-")) -->
  <div class="flex flex-wrap items-center justify-center">
    <wegow-select
      :id="idSelector"
      class="transparent"
      :class="showButton ? 'select' : 'w-full'"
      background-select="background-transparent"
      :border-select="borderSelect"
      :options="regions"
      :value="regionSelected"
      :placeholder="$t('wegow.headers.regionSelectorPlaceholder')"
      :no-options-label="$t('wegow.headers.regionSelectorNoLoad')"
      :no-result-label="$t('wegow.headers.regionSelectorNoResult')"
      object-label="name"
      :special-label="true"
      :special-single-label="true"
      track-by="name"
      border="1px solid #7F8295"
      @select="selectRegion($event, !showButton)"
    >
      <!-- @search-change="getCities" -->
      <template #option="data">
        <i :class="data.data.option.code" class="flag mr-2" />
        {{
          data.data.option.name.includes("-")
            ? data.data.option.name.split("-")[1]
            : data.data.option.name
        }}
      </template>
      <template #singleLabel="data">
        <i :class="data.data.option.code" class="flag mr-2" />
        {{
          data.data.option.name.includes("-")
            ? data.data.option.name.split("-")[1]
            : data.data.option.name
        }}
      </template>
    </wegow-select>
    <w-navigation
      v-if="showButton"
      class="home-btn"
      :params="{
        name: 'MainRegionPage',
        params: {
          region: parseRegion
        }
      }"
      :class="regionSelected && regionSelected.code ? '' : 'disableEvents'"
      :full="false"
      @click.prevent="selectRegion(regionSelected, true)"
    >
      <template #link>
        <wegow-button
          button-id="go-to-wegow-button"
          background="opacity"
          color="topaz"
          type="button"
          :text="$t('wegow.headers.goToWegow')"
        />
      </template>
    </w-navigation>
  </div>
</template>

<script setup>
import { useGeneral } from "@/composables/useGeneral";
import { useUser } from "@/composables/useUser";

import WegowSelect from "@/components/general/forms/WegowSelect";
import WegowButton from "@/components/general/forms/WegowButton";
import WNavigation from "@/components/general/ui/WNavigation";

import { computed, onBeforeMount, ref } from "vue";
import { VueCookieNext } from "vue-cookie-next";
import { useRoute } from "vue-router";
import { DEFAULT_LANGUAGES } from "@/constants.js";

const props = defineProps({
  borderSelect: {
    type: String,
    default: ""
  },
  showButton: {
    type: Boolean,
    default: true
  },
  idSelector: {
    type: String,
    default: ""
  }
});

const $cookie = VueCookieNext;
const { regions, getRegions, getFooter, getNavbar } = useGeneral();
const { isAuth, userDetail, updateUser } = useUser();
const route = useRoute();
const regionSelected = ref(regions[0]);

onBeforeMount(async () => {
  if (regions.value?.length === 0) {
    await getRegions();
  }
  if (
    $cookie.getCookie("wegow.user-region") &&
    ($cookie.getCookie("wegow.user-region").length === 2 ||
      $cookie.getCookie("wegow.user-region").includes("-"))
  ) {
    let newRegion = regions.value.find(
      region =>
        region.code === $cookie.getCookie("wegow.user-region") ||
        region.code.includes("-" + $cookie.getCookie("wegow.user-region"))
    );
    regionSelected.value = newRegion || regions.value[0];
  } else if (route.params?.region) {
    let newRegion = regions.value.find(
      region =>
        region.code === route.params.region ||
        region.code.includes("-" + route.params.region)
    );
    regionSelected.value = newRegion || regions.value[0];
  } else {
    regionSelected.value = regions.value[0];
  }
});

const parseRegion = computed(() => {
  if (!regionSelected.value) {
    return "es";
  } else if (regionSelected.value.code.includes("-")) {
    return regionSelected.value.code.split("-")[1];
  } else {
    return regionSelected.value.code;
  }
});

const selectRegion = async (region, change) => {
  regionSelected.value = region;
  if (change) {
    let realRegion = "";
    if (region.code.includes("-")) {
      realRegion = region.code.split("-")[1];
    } else {
      realRegion = region.code;
    }
    let match_expression =
      process.env.VUE_APP_NUXT_ENV !== "local" ? "https://www" : "http://www";
    $cookie.setCookie("wegow.user-region", realRegion, {
      path: "/",
      expire: 60 * 60 * 24 * 365,
      domain: process.env.VUE_APP_NUXT_HOST.replace(match_expression, ""),
      secure: process.env.VUE_APP_NUXT_ENV !== "local"
    });
    if (isAuth.value) {
      await updateUser({
        id: userDetail.value.id,
        region: realRegion
      });
    }
    if (!props.showButton) {
      let regionMap =
        DEFAULT_LANGUAGES[realRegion] + "-" + realRegion.toUpperCase();
      let realOne = document.querySelectorAll(
        'link[hreflang="' + regionMap + '"]'
      );
      if (realOne.length === 1) {
        window.location.href = realOne[0].href;
      } else {
        let newUrl = window.location.href.replace(
          "/" + route.params?.region,
          "/" + realRegion
        );
        window.location.href = newUrl;
      }
    } else {
      getFooter();
      getNavbar();
    }
  }
};
</script>

<style lang="scss" scoped>
.home-btn {
  margin-left: 2.5rem;
  @media screen and (max-width: 420px) {
    margin-left: 1.25em;
    margin-right: 1.25em;
    margin-top: 17px;
  }
}
.select {
  width: 14rem;
}
.flag {
  display: inline-block;
  width: 22px;
  height: 13px;
  margin-right: 5px;
  vertical-align: middle;
  background-position: center;
  background-size: contain;
  &.es-es,
  &.es {
    background-image: url("@/assets/images/es.svg");
  }
  &.es-mx,
  &.mx {
    background-image: url("@/assets/images/mx.svg");
  }
  &.es-co,
  &.co {
    background-image: url("@/assets/images/co.svg");
  }
  &.es-pe,
  &.pe {
    background-image: url("@/assets/images/pe.svg");
  }
  &.es-ar,
  &.ar {
    background-image: url("@/assets/images/ar.svg");
  }
  &.es-cl,
  &.cl {
    background-image: url("@/assets/images/cl.svg");
  }
  &.de-de,
  &.de {
    background-image: url("@/assets/images/de.svg");
  }
  &.en-gb,
  &.gb {
    background-image: url("@/assets/images/gb.svg");
  }
  &.fr-fr,
  &.fr {
    background-image: url("@/assets/images/fr.svg");
  }
  &.it-it,
  &.it {
    background-image: url("@/assets/images/it.svg");
  }
  &.pt-pt,
  &.pt {
    background-image: url("@/assets/images/pt.svg");
  }
  &.de-ch,
  &.ch {
    background-image: url("@/assets/images/ch.svg");
  }
  &.en-nl,
  &.nl {
    background-image: url("@/assets/images/nl.svg");
  }
  &.en-ie,
  &.ie {
    background-image: url("@/assets/images/ie.svg");
  }
  &.de-at,
  &.at {
    background-image: url("@/assets/images/at.svg");
  }
  &.fr-be,
  &.be {
    background-image: url("@/assets/images/be.svg");
  }
  &.pt-br,
  &.br {
    background-image: url("@/assets/images/br.svg");
  }
  &.en-us,
  &.us {
    background-image: url("@/assets/images/us.svg");
  }
  &.es-us,
  &.us {
    background-image: url("@/assets/images/us.svg");
  }
  &.fr-ca,
  &.ca {
    background-image: url("@/assets/images/ca.svg");
  }
  &.en-au,
  &.au {
    background-image: url("@/assets/images/au.svg");
  }
  &.en-se,
  &.se {
    background-image: url("@/assets/images/se.svg");
  }
  &.en-es,
  &.es {
    background-image: url("@/assets/images/es.svg");
  }
  &.fr-ch,
  &.ch {
    background-image: url("@/assets/images/ch.svg");
  }
  &.en-ca,
  &.ca {
    background-image: url("@/assets/images/ca.svg");
  }
}
/*  */
</style>
